import React, { useState, useEffect } from "react";
import ContactForm from "./ButtonsForm/HireOnDemand";
import "./Home.css";
import Card from "../SecondSetion/Card";
import ThirdCard from "../ThirdSection/ThirdCard";
import Banner from "../FourthSection/Banner";
import TestimonialCarousel from "../testinomials/TestimonialCarousel";
import AboutUs from "./AboutUs";
import { Helmet } from "react-helmet";
import StatsSection from "./StatsSection";
// Custom typewriter hook
const useTypewriter = (
  words,
  typingSpeed = 120,
  deletingSpeed = 60,
  pause = 2000
) => {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (index === words.length) {
      setIndex(0);
    }

    if (!deleting && subIndex === words[index].length) {
      setTimeout(() => setDeleting(true), pause);
      return;
    }

    if (deleting && subIndex === 0) {
      setDeleting(false);
      setIndex((prev) => (prev + 1) % words.length);
      return;
    }

    const timeout = setTimeout(
      () => {
        const nextSubIndex = subIndex + (deleting ? -1 : 1);
        setText(words[index].substring(0, nextSubIndex));
        setSubIndex(nextSubIndex);
      },
      deleting ? deletingSpeed : typingSpeed
    );

    return () => clearTimeout(timeout);
  }, [subIndex, index, deleting, words, typingSpeed, deletingSpeed, pause]);

  return text;
};

const Home = () => {
  const [showHireOnDemand, setShowHireOnDemand] = useState(false);
  const [showOutsourceProject, setShowOutsourceProject] = useState(false);
  const [showBuildOffshoreCOE, setShowBuildOffshoreCOE] = useState(false);

  const animatedText = useTypewriter(
    [
      "Microsoft Copilot",
      "Microsoft Power Platform",
      "Microsoft 365",
      "Microsoft Azure",
      "Microsoft Dynamics 365",
    ],
    120, // typing speed
    60, // backspace speed
    2000 // pause duration
  );

  return (
    <>
      <Helmet>
        <title>
          Navishaa – Certified Tech Resources at Your Fingertips | On-Demand IT
          Experts
        </title>

        {/* Description */}
        <meta
          name="description"
          content="Access certified technical experts instantly with Navishaa’s on-demand IT resource model. Scalable, flexible, and secure tech talent for all your project needs."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.navishaa.com/" />

        {/* Open Graph (OG) tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Navishaa – Certified Tech Resources at Your Fingertips | On-Demand IT Experts"
        />
        <meta
          property="og:description"
          content="Access certified technical experts instantly with Navishaa’s on-demand IT resource model. Scalable, flexible, and secure tech talent for all your project needs."
        />
        <meta property="og:url" content="https://www.navishaa.com/" />
        <meta property="og:site_name" content="navishaa" />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/career-opportunities-banner.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="629" />

        {/* Twitter tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@navishaa" />
        <meta
          name="twitter:title"
          content="Navishaa – Certified Tech Resources at Your Fingertips | On-Demand IT Experts"
        />
        <meta
          name="twitter:description"
          content="Access certified technical experts instantly with Navishaa’s on-demand IT resource model. Scalable, flexible, and secure tech talent for all your project needs."
        />
        <meta
          name="twitter:image"
          content="https://www.navishaa.com//images/career-opportunities-banner.png"
        />

        {/* LinkedIn tags */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.navishaa.com/career-opportunities"
        />
        <meta
          property="og:title"
          content="Navishaa – Certified Tech Resources at Your Fingertips | On-Demand IT Experts"
        />
        <meta
          property="og:description"
          content="Access certified technical experts instantly with Navishaa’s on-demand IT resource model. Scalable, flexible, and secure tech talent for all your project needs."
        />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/career-opportunities-banner.png"
        />

        {/* Structured Data - Schema.org */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Navishaa – Certified Tech Resources at Your Fingertips | On-Demand IT Experts",
        "author": {
          "@type": "Person",
          "name": "Navishaa"
        },
        "datePublished": "2023-09-05",
        "dateModified": "2023-09-05",
        "image": {
          "@type": "ImageObject",
          "url": "https://www.navishaa.com/images/social-banner.png",
          "width": 1200,
          "height": 629
        },
        "publisher": {
          "@type": "Organization",
          "name": "Navishaa",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.navishaa.com//images/logo.png",
            "width": 1854,
            "height": 503
          }
        },
        "mainEntityOfPage": "https://www.navishaa.com",
        "url": "https://www.navishaa.com",
        "description": "Access certified technical experts instantly with Navishaa’s on-demand IT resource model. Scalable, flexible, and secure tech talent for all your project needs."
      }
    `}
        </script>
      </Helmet>
      <section
        className="pt-28 md:pt-60 bg-white bg-cover h-screen"
        style={{
          backgroundImage:
            'url("https://res.cloudinary.com/dbitupkaa/image/upload/v1747380834/dotone-Dav4Idbc_qfmhok.jpg")',
          backgroundSize: "auto 100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left center",
        }}
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative text-center">
          <div className="relative">
            <h1 className="mx-auto text-center font-Calistoga font-normal text-3xl text-slate-600 mb-0 md:text-[36px] leading-[40px]">
              With Our Resource-as-a-service Model,
            </h1>
            <h1 className="mx-auto text-center font-normal text-slate-600 font-Calistoga text-3xl lg:mb-2 md:text-[36px] leading-[40px]">
              Hire Certified Technical Experts On{" "}
              <span
                className="index-module_type__E-SaG dynamic-text"
                style={{
                  backgroundClip: "text",
                  color: "transparent",
                  backgroundImage:
                    "linear-gradient(to right, rgb(195, 78, 215), rgb(248, 130, 153))",
                }}
              >
                {animatedText}
              </span>
              <span className="blinking-cursor"></span>
            </h1>

            {/* Floating Icons */}
            <div className="hidden xl:flex relative">
              <div className="absolute -top-40 left-48 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden balloon">
                <img
                  src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318434/microsoftAzure-Dc7UFzJF_crfuyy.png"
                  alt="Top Left"
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="absolute -top-36 right-28 transform translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-white shadow-lg overflow-hidden balloon">
                <img
                  src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318457/M365-CJftAqtU_lnmapu.png"
                  alt="Top Right"
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="absolute -bottom-16 left-40 transform -translate-x-1/2 translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden balloon">
                <img
                  src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318446/Copilot-DhV6uIFg_px8c5y.jpg"
                  alt="Bottom Left"
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="absolute -bottom-20 right-28 transform translate-x-1/2 translate-y-1/2 flex items-center justify-center w-14 h-14 bg-gray-200 rounded-full border-4 border-gray-200 shadow-lg overflow-hidden balloon">
                <img
                  src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318468/powerapp-CWh0_WUX_lca0og.png"
                  alt="Bottom Right"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>
          </div>

          <p className="mx-auto text-center text-lg lg:text-[18px] text-gray-600 font-medium leading-6 mb-6 font-Questrial">
            Your path to effortless engagement, retention, and building loyal
            customers
          </p>

          {/* <div className="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0 justify-center md:px-0">
            <button className="py-1.5 px-6 text-sm font-medium text-center text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-full md:w-auto font-Questrial">
              Hire On-demand
            </button>
            <button className="py-1.5 px-6 text-sm font-medium text-center text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-full md:w-auto font-Questrial">
              Outsource Project
            </button>
            <button className="py-1.5 px-6 text-sm font-medium text-center text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-full md:w-auto font-Questrial">
              Offshore CoE
            </button>
          </div> */}
          <div className="flex flex-row space-x-2 justify-center px-4 md:space-x-6 md:px-0">
            <button
              className="py-1 px-3 text-xs md:text-sm md:py-2 md:px-6 font-medium text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-auto font-Questrial"
              aria-label="Hire On-demand"
            >
              Hire On-demand
            </button>
            <button
              className="py-1 px-3 text-xs md:text-sm md:py-2 md:px-6 font-medium text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-auto font-Questrial"
              aria-label="Outsource Project"
            >
              Outsource Project
            </button>
            <button
              className="py-1 px-3 text-xs md:text-sm md:py-2 md:px-6 font-medium text-white bg-[#5c68f2] hover:bg-[#ba195f] shadow-xs transition-all duration-500 rounded-xl w-auto font-Questrial"
              aria-label="Offshore CoE"
            >
              Offshore CoE
            </button>
          </div>
        </div>
      </section>
      <AboutUs />
      {/* <StatsSection /> */}
      <Card />
      <ThirdCard />
      <TestimonialCarousel />
      <Banner />
    </>
  );
};

export default Home;
